// removed by extract-text-webpack-plugin
module.exports = {"addresses":"Addresses__addresses","addressesContent":"Addresses__addressesContent","title":"Addresses__title","mailAddress":"Addresses__mailAddress","growDotQello":"Addresses__growDotQello","growDotBlue":"Addresses__growDotBlue","growDotGolden":"Addresses__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Addresses/Addresses.scss
// module id = 1887
// module chunks = 0